/**
 * <cart-recommendations>: loads the cart page's "Sepetini Tamamla" rail.
 *
 * Tries Shopify's native complementary recommendations first; if the store
 * has none configured for the seed product, falls back to Shopify's related
 * recommendations (always available, no merchant setup required). Built as
 * its own small element rather than reusing assets/complementary-products.js
 * because that element only ever fetches one URL - the fallback behaviour
 * here is a real requirement, not something to bolt onto shared PDP code.
 */
(function () {
  var INNER_SELECTOR = '.complementary-products';

  function extractInnerHTML(responseText) {
    var doc = document.createElement('div');
    doc.innerHTML = responseText;
    var inner = doc.querySelector(INNER_SELECTOR);
    return inner && inner.innerHTML.trim().length ? inner.innerHTML : null;
  }

  function load(url) {
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (text) {
        return text ? extractInnerHTML(text) : null;
      })
      .catch(function () {
        return null;
      });
  }

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.observer) this.observer.disconnect();
      var loadId = this.loadId = (this.loadId || 0) + 1;
      var complementaryUrl = this.getAttribute('data-url-complementary');
      var relatedUrl = this.getAttribute('data-url-related');
      var target = this.querySelector(INNER_SELECTOR);
      if (!target) return;

      var observer = new IntersectionObserver(
        function (entries) {
          if (!this.isConnected || loadId !== this.loadId || !entries[0].isIntersecting) return;
          observer.disconnect();
          this.observer = null;

          // The two-step complementary-then-related fetch (see file
          // comment) can take a visible moment, and until it resolves the
          // rail was empty space with no indication anything was coming -
          // confirmed on physical iPhone video as "no Quick Add visible",
          // when the real cause was the whole rail (cards, not just the
          // icon) not having loaded yet. Reuses the theme's own existing
          // .loader/.loader-indeterminate bar rather than a new component.
          this.classList.add('is-loading');

          load(complementaryUrl)
            .then(
              function (html) {
                if (html) return html;
                return load(relatedUrl);
              }.bind(this)
            )
            .then(
              function (html) {
                if (!this.isConnected || loadId !== this.loadId) return;
                this.classList.remove('is-loading');
                if (html) {
                  target.innerHTML = html;
                  target.dispatchEvent(new CustomEvent('theme:cards:rendered', {bubbles: true}));
                } else {
                  var wrapper = this.closest('.cart-recs');
                  if (wrapper) wrapper.classList.add('is-empty');
                }
              }.bind(this)
            );
        }.bind(this),
        { rootMargin: '0px 0px 400px 0px' }
      );

      this.observer = observer;
      observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      this.loadId = (this.loadId || 0) + 1;
      this.classList.remove('is-loading');
    }
  }

  customElements.get('cart-recommendations') || customElements.define('cart-recommendations', CartRecommendations);
})();
